import './styles.scss';
import React from 'react';
import {Descriptions} from "antd";
import {IOfficer} from "../../../api/Officer/Officer.types";
import {OFFICER_DETAILS_FIELD_MAP} from "./Officers.details.fieldMap";
import {StringUtils} from "../../../global/utils/string";
import DescriptionManager from "../../../global/utils/DescriptionManager";

interface Props {
    officer: IOfficer
}

function OfficerDetails({officer}: Props) {

    function renderItem(field, value) {
        return (
            <Descriptions.Item key={field} label={field}>
                {value}
            </Descriptions.Item>
        )
    }

    let descriptionManager = new DescriptionManager<IOfficer>({
        fieldMappings: OFFICER_DETAILS_FIELD_MAP,
        record: officer,
        renderItem: renderItem,
        globalFormatField: StringUtils.camelCaseToRegular,
    });

    return (
        <div className='officer-details-component'>
            <div className='officer-details-header'>
                <div className='top'>
                    <div className='name'>{officer.name}</div>
                </div>
                <div className='description'>

                </div>

            </div>
            <Descriptions size="small" bordered layout='vertical' column={{xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1}}>
                {descriptionManager.renderItems()}
            </Descriptions>
        </div>
    )
}

export default OfficerDetails;